function excursion_group_toggle() {
	$(".panel-header").click(
		function(){
			$(this).next(".excursion-group, .tour-grid").slideToggle('fast', function(){
				if ($(this).is(':hidden')) {
					$(this).prev().find('a').removeClass('downArrow').addClass('upArrow').attr('aria-expanded', 'false');
				}else{
					$(this).prev().find('a').removeClass('upArrow').addClass('downArrow').attr('aria-expanded', 'true');
				}
				return false;
		});
	});		
	$("input[name=sharedEx]").click( function(){
		$('.excursion-group .no-excursions-limited-messagebox, .tour-grid .no-excursions-limited-messagebox').remove();							
		if($("input[name=sharedEx]:checked").length > 5){			
			$('.no-excursions-limited-messagebox').clone().prependTo($(this).closest('.share'));
			$(this).prev('.no-excursions-limited-messagebox').show();					
			$(this).removeAttr("checked");	
			$('.no-excursions-limited-messagebox .errorbox-close-button').click(function() {
				$(this).closest('.no-excursions-limited-messagebox').remove();
			});		
		}		
	}); 		
}

$(document).ready(function(){		
	no_excursions_selected();		
});

function no_excursions_selected(){
	$(this).next().closest('.no-excursions-selected-messagebox').hide();
	$(this).next().closest('.no-excursions-limited-messagebox').hide();
	
	$('.share-icon').click(function() {		
		if($("input[name=sharedEx]:checked").length <= 0){		
			$(this).next('.no-excursions-selected-messagebox').show();
		}
		if($("input[name=sharedEx]:checked").length > 5){		
			$(this).next().next('.no-excursions-limited-messagebox').show();
		}
	});
	
	$('.no-excursions-selected-messagebox .errorbox-close-button').click(function() {
		$(this).closest('.no-excursions-selected-messagebox').hide();
		});
	$('.no-excursions-limited-messagebox .errorbox-close-button').click(function() {
		$(this).closest('.no-excursions-limited-messagebox').hide();
		});
		
}


